import { createContext } from "react";

export type DashboardContextValue = {
  isDashboard: boolean;
};

export const DashboardContext = createContext<DashboardContextValue>({
  isDashboard: false,
});
